import ErrorBoundary from '@shared/components/ErrorBoundaries/ErrorBoundary';
import LayoutContainer, { LayoutBodyType } from '@shared/components/Layout/LayoutContainer';
import SecureMsalRoute from '@shared/components/SecureMsalRoute/SecureMsalRoute';
import useAuthService from '@shared/hooks/useAuthService';
import importRemote from '@shared/utilities/federation/loadremote';
import React, { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import PageLoader from '../../components/PageLoading';

const VDPRemote = React.lazy(() =>
    importRemote({
        remoteName: 'VDP',
        scope: 'remote_vdp',
        module: 'Application',
        remoteUrlLocation: process.env.REMOTE_VDP,
    })
);

const VDP = () => {
    const { stockNum } = useParams();

    const { authService } = useAuthService();

    return (
        <LayoutContainer includeFooter={true} layoutType={LayoutBodyType.FullWidth}>
            <ErrorBoundary>
                <SecureMsalRoute>
                    <Suspense fallback={<PageLoader label="vdp-loading" />}>
                        <VDPRemote
                            stockNum={stockNum}
                            enableAttendees={process.env.ENABLE_VDP_ATTENDEES}
                            enableConditionReport={process.env.ENABLE_VDP_CONDITIONREPORT}
                            authService={authService}
                        />
                    </Suspense>
                </SecureMsalRoute>
            </ErrorBoundary>
        </LayoutContainer>
    );
};

export default VDP;
